import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=c41be070&scoped=true&"
import script from "./assignment.vue?vue&type=script&lang=js&"
export * from "./assignment.vue?vue&type=script&lang=js&"
import style0 from "./assignment.vue?vue&type=style&index=0&id=c41be070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41be070",
  null
  
)

export default component.exports